import { SegmentedValue } from 'antd/es/segmented';
import { atom } from 'jotai';

const activeFilterAtom = atom<SegmentedValue>('total');
const selectedWebhookAtom = atom<string[]>([]);


const webhooksSettingsAtom = atom((get) => {
    return {
        activeFilter: get(activeFilterAtom),
        selectedWebhook: get(selectedWebhookAtom),
    }
});

export {
    activeFilterAtom,
    selectedWebhookAtom,
    webhooksSettingsAtom,
}
